// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"b_-z","inlineTitle":"c_-z","sponsoredAdsWrapper":"d_-z","marketplaceRecosWrapper":"e_-z","brandShopTheLookWrapper":"f_-z"};